export default function getViewPort(thisViewPort, isUnderscore) {
  if (thisViewPort) {
    if (thisViewPort.startsWith('desktop')) return isUnderscore ? '0' : '0';
    if (thisViewPort.startsWith('small')) return isUnderscore ? '76_8' : '76.8';
    if (thisViewPort.startsWith('mobile')) return isUnderscore ? '37_5' : '37.5';
    return thisViewPort;
  }
  return null;
}
